<template>
  <div class="item-list" v-bind="$attrs">
    <TransitionGroup :css="false" @before-enter="beforeEnter" @enter="onTransitionGroupEnter">
      <slot
        v-for="(one, index) in displayItems"
        v-bind="{ item: one, index, totalIndex: index + (currentPage - 1) * settings.itemsPerPage, currentPage }"
        :key="one.id ?? one.name"
        name="body"
      />
    </TransitionGroup>
  </div>
  <template v-if="mobile || tablet">
    <div v-if="totalRevealedCount < totalCount" class="view-more-btn font2 bold" @click="viewMoreClick">VIEW MORE</div>
  </template>
  <Pagination
    v-else
    v-model:current-page="currentPage"
    :items-per-page="settings.itemsPerPage"
    :max-pagination="settings.maxPagination"
    :total-count="totalCount"
  />
</template>
<script setup lang="ts">
  import { useDisplay } from 'vuetify'
  import { gsap } from 'gsap'
  const { mobile, sm: tablet, mdAndUp: PC } = useDisplay()

  const props = defineProps({
    items: {
      type: Array as PropType<any[]>,
      required: true,
      default: () => [],
    },
    settings: {
      type: Object,
      default: () => {
        return {
          initialRevealNumber: {
            mobile: 10,
            tablet: 10,
          },
          revealNumberPerClick: {
            mobile: 6,
            tablet: 6,
          },
          itemsPerPage: 12,
          maxPagination: 5,
        }
      },
    },
  })

  const currentPage = defineModel<number>('currentPage', { default: 1 })
  const totalCount = computed(() => props.items.length)
  const totalRevealedCount = ref(0)
  const displayItems = computed(() =>
    PC.value
      ? props.items.slice(
          (currentPage.value - 1) * props.settings.itemsPerPage,
          currentPage.value * props.settings.itemsPerPage
        )
      : props.items.slice(0, totalRevealedCount.value)
  )

  function viewMoreClick() {
    totalRevealedCount.value += props.settings.revealNumberPerClick[tablet.value ? 'tablet' : 'mobile']
  }

  // reset
  watch(PC, () => {
    currentPage.value = 1
  })

  watch(
    tablet,
    (newVal) => {
      if (newVal) totalRevealedCount.value = props.settings.initialRevealNumber.tablet
    },
    { immediate: true }
  )

  watch(
    mobile,
    (newVal) => {
      if (newVal) totalRevealedCount.value = props.settings.initialRevealNumber.mobile
    },
    { immediate: true }
  )

  watch(
    () => props.items,
    () => {
      if (PC.value) currentPage.value = 1
      else totalRevealedCount.value = props.settings.initialRevealNumber[tablet.value ? 'tablet' : 'mobile']
    }
  )
  ///

  function onTransitionGroupEnter(el: any, done: any) {
    // only for the view more click
    if (totalRevealedCount.value > props.settings.initialRevealNumber[tablet.value ? 'tablet' : 'mobile']) {
      gsap.to(el, {
        opacity: 1,
        scale: 1,
        onComplete: done,
      })
    } else {
      el.style.scale = 1
      el.style.opacity = 1
    }
  }
  function beforeEnter(el: any) {
    el.style.scale = 0
    el.style.opacity = 0
  }
  defineExpose({
    viewMoreClick,
    totalRevealedCount,
  })
</script>
<style lang="scss" scoped>
  .item-list {
    transition: height 0.3s;
  }
  .view-more-btn {
    font-size: 22px;
    text-align: center;
    position: relative;
    padding: 20px 0;
    margin-bottom: -20px;
    cursor: pointer;
    &::after {
      content: '';
      position: absolute;
      top: calc(100% - 22px);
      left: calc(50% - 10px);
      width: 0px;
      height: 0px;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid #464646;
      transition: top 0.2s;
    }
    &:active {
      &::after {
        top: calc(100% - 18px);
      }
    }
  }
</style>
